module.exports = __webpack_public_path__ + "static/media/1-circle-img-medical101.6f0af135.png";